import {OrderInput} from "@/endpoints/rutsolve/gql/generated/types"

export class SaleOrderSelector {
    static readonly input: string = "SALE_ORDER_SELECTOR_INPUT"
    static readonly orderID: string = "SALE_ORDER_SELECTOR_ORDER_ID"

    private static defaultInput: OrderInput = {
        orderFilter: {
            statuses: [],
            types: [
                "SALE_CREDIT",
                "SALE_DEBIT",
                "SALE_OFFER"
            ]
        },
        order: "UPDATED_AT_DESCENDING",
        plot: {
            items: 10,
            page: 1
        },
    }

    public static readInput(): OrderInput {
        const storage: OrderInput = JSON.parse(sessionStorage.getItem(this.input)) as OrderInput
        if (storage) {
            if (!storage.orderFilter) {
                storage.orderFilter = {}
            }
            if (!storage.orderFilter.types || storage.orderFilter.types.length == 0) {
                storage.orderFilter.types = [
                    "SALE_CREDIT",
                    "SALE_DEBIT",
                    "SALE_OFFER"
                ]
            }
            return storage
        }
        return this.defaultInput
    }

    public static readOrderID(): string {
        return sessionStorage.getItem(this.orderID)
    }

    public static writeInput(input: OrderInput) {
        sessionStorage.setItem(this.input, JSON.stringify(input))
    }

    public static writeOrderID(input: string) {
        sessionStorage.setItem(this.orderID, input)
    }

    public static deleteInput() {
        sessionStorage.removeItem(this.input)
    }

    public static deleteOrderID() {
        sessionStorage.removeItem(this.orderID)
    }
}
